<template>
  <div class="dash-preview" v-if="galleryPriceList.length > 0">
    <ModalPriceList :price-list="galleryPriceList"
                    :currency="data.currency"
                    :is-demo="data.isDemo"
                    :event-name="data.event_name" is-preview
    />
  </div>
</template>


<script>
import ModalPriceList from "@/domain/galleries/modals/ModalPriceList.vue";
import {mapGetters} from "vuex";
export default {
  name: 'PreviewPriceList',
  components: {ModalPriceList},
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters('galleries', ['priceList']),
    galleryPriceList() {
      if (!this.data || !this.data.items || !this.data.items.length) return []
      return this.priceList({ items: this.data.items});
    }
  },
  watch: {
    galleryPriceList: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            // Add a small delay to ensure the modal is fully initialized
            setTimeout(() => {
              this.$bvModal.show('modalPriceList')
            }, 100)
          })
        }
      }
    }
  }
}
</script>
